import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import ReactTost from "../../ReactTost";
import { useTranslation } from "react-i18next";

const UserBotDelete = (props) => {
  const {t} = useTranslation(); 
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const[loading,setLoading]=useState(false)
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const user=localStorage.getItem("id");
  
  // function getUserBot(){
  //   setLoading(true)
  //   axios
  //    .get(`${API_URL}/${API_VERSION}/bot/user/${user}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     })
  //    .then((response) => {
  //       setLoading(false)
  //      if(response.data.length<0){
  //       localStorage.removeItem("firstBot");
  //      }
  //      else{
  //       localStorage.setItem("firstBot",response.data[0].id)
  //      }
  //     })
  //    .catch((error) => {
  //       setLoading(false)
  //       setType("Danger");
  //       setMessage(t("Something went to wrong."));
  //       setShowAlert(true);
  //     });
  // }
  // useEffect(() => {
  //   getUserBot();
  // }, []);
  
  function BotDelete(id) {
    if (id) {
      setLoading(true)
      axios
        .delete(`${API_URL}/${API_VERSION}/bot/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setLoading(false)
          setType("Success");
          setMessage(t("Your bot is deleted."));
          setShowAlert(true);
          props.onDeleteSuccess();
          props.onHide();
        })
        .catch((error) => {
          setLoading(false)
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  }

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />

      {/* {loading ? <Loader/> : */}
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("Delete Chatbot")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t("Are you sure you want to delete your Chatbot? This action cannot be undone.")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="button" onClick={props.onHide}>
            {t("Cancel")}
          </button>
          <Button className="button color_orange" onClick={() => {BotDelete(props.deleteBotId);}}>{t("Delete")}</Button>
        </Modal.Footer>
      </Modal>
      {/* } */}
    </>
  );
};

export default UserBotDelete;
